import { Volume2, VolumeX } from "lucide-react";
import { useState } from "react";

function AudioToggle() {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={() => setEnabled((value) => !value)}
        className="inline-flex items-center gap-2 rounded-full border border-museum-bone/15 bg-museum-black/50 px-4 py-2 text-xs uppercase tracking-[0.22em] text-museum-muted transition hover:border-museum-gold/60 hover:text-museum-bone"
        aria-pressed={enabled}
      >
        {enabled ? <Volume2 size={15} aria-hidden="true" /> : <VolumeX size={15} aria-hidden="true" />}
        Ambient {enabled ? "on" : "off"}
      </button>
      {enabled && <p className="text-right text-xs text-museum-gold/80">Ambient mode enabled</p>}
    </div>
  );
}

export default AudioToggle;
